<template>
  <svg viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.888672 0.805664V27.1946L24.791 14.0001L0.888672 0.805664Z" fill="currentColor" />
  </svg>
</template>
